/**
 * Metadata voor project-basisvelden (UI labels, editability).
 * docs/rapporten/11-project-basis.md
 */
export const PROJECT_BASIS_FIELDS = [
    {
        key: 'name',
        label: 'Naam',
        editableAfterCreate: true,
        requiredOnCreate: true,
        section: 'identity',
        hint: 'Zichtbaar in de project-switcher en titels.',
    },
    {
        key: 'slug',
        label: 'Slug',
        editableAfterCreate: false,
        requiredOnCreate: true,
        section: 'identity',
        hint: 'URL-segment voor inbound: /api/inbound/{slug}. Niet wijzigen na live formulieren.',
    },
    {
        key: 'domain',
        label: 'Primair domein',
        editableAfterCreate: true,
        requiredOnCreate: false,
        section: 'identity',
    },
    {
        key: 'color',
        label: 'Kleur',
        editableAfterCreate: true,
        requiredOnCreate: false,
        section: 'identity',
    },
    {
        key: 'from_name',
        label: 'Afzendernaam (default)',
        editableAfterCreate: true,
        requiredOnCreate: false,
        section: 'mail',
    },
    {
        key: 'signature_html',
        label: 'Handtekening (HTML)',
        editableAfterCreate: true,
        requiredOnCreate: false,
        section: 'mail',
        hint: 'Optioneel; wordt onder mail gezet waar de app dat ondersteunt.',
    },
    {
        key: 'allowed_origins',
        label: 'Toegestane origins (CORS)',
        editableAfterCreate: true,
        requiredOnCreate: false,
        section: 'inbound',
        hint: 'Volledige URL’s van sites die inbound mogen aanroepen.',
    },
    {
        key: 'branding',
        label: 'Branding (JSON)',
        editableAfterCreate: true,
        requiredOnCreate: false,
        section: 'branding',
        hint: 'Uitbreiding later; mag leeg blijven.',
    },
];
export function inboundWebhookUrl(publicApiOrigin, slug) {
    const base = publicApiOrigin.replace(/\/$/, '');
    return `${base}/api/inbound/${encodeURIComponent(slug)}`;
}
/** Voorstel slug uit weergavenaam (handmatig aanpasbaar vóór create). */
export function slugFromDisplayName(name) {
    return name
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 64);
}
//# sourceMappingURL=projectBasis.js.map